import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useGlobalStore } from 'stores/global';

export default function useRouteChangeHandler() {
  const pathname = usePathname();
  const setIsPageLoading = useGlobalStore((state) => state.setIsPageLoading);

  useEffect(() => {
    setIsPageLoading(false);
  }, [pathname, setIsPageLoading]);
}
